(() => {
  const TOOLBAR_SELECTOR = '[data-obx-condition-toolbar]';
  const CARD_SELECTOR = '.obx-product-card[data-obx-conditions]';

  const getCards = (toolbar) => {
    const container = toolbar.closest('#ProductGridContainer') || document;
    return Array.from(container.querySelectorAll(CARD_SELECTOR));
  };

  const updateCount = (toolbar, visible, total, condition) => {
    const section = toolbar.closest('.ob-collection-grid');
    const target = section?.querySelector('.product-count__text span');
    if (!target) return;
    if (!toolbar.dataset.obxOriginalCount) toolbar.dataset.obxOriginalCount = target.textContent.trim();
    target.textContent = condition === 'all'
      ? toolbar.dataset.obxOriginalCount
      : `${visible} matching ${visible === 1 ? 'product' : 'products'} on this page`;
  };

  const applyFilter = (toolbar, condition) => {
    const cards = getCards(toolbar);
    let visible = 0;

    cards.forEach((card) => {
      const item = card.closest('.grid__item');
      if (!item) return;
      const conditions = (card.dataset.obxConditions || '').split(/\s+/).filter(Boolean);
      const show = condition === 'all' || conditions.includes(condition);
      item.hidden = !show;
      item.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) visible += 1;
    });

    toolbar.dataset.obxActiveCondition = condition;
    toolbar.querySelectorAll('[data-obx-condition]').forEach((button) => {
      const active = button.dataset.obxCondition === condition;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const container = toolbar.closest('#ProductGridContainer');
    const empty = container?.querySelector('[data-obx-condition-empty]');
    if (empty) empty.hidden = visible !== 0;
    updateCount(toolbar, visible, cards.length, condition);
  };

  const initialiseToolbar = (toolbar) => {
    const cards = getCards(toolbar);
    const represented = new Set();
    cards.forEach((card) => {
      (card.dataset.obxConditions || '').split(/\s+/).filter(Boolean).forEach((value) => represented.add(value));
    });

    toolbar.querySelectorAll('[data-obx-condition]').forEach((button) => {
      const condition = button.dataset.obxCondition;
      button.hidden = condition !== 'all' && !represented.has(condition);
    });

    const requested = toolbar.dataset.obxActiveCondition || 'all';
    applyFilter(toolbar, represented.has(requested) || requested === 'all' ? requested : 'all');
    toolbar.dataset.obxInitialised = 'true';
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll(TOOLBAR_SELECTOR).forEach(initialiseToolbar);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-obx-condition]');
    if (!button) return;
    const toolbar = button.closest(TOOLBAR_SELECTOR);
    if (!toolbar) return;
    event.preventDefault();
    applyFilter(toolbar, button.dataset.obxCondition || 'all');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(TOOLBAR_SELECTOR) && node.dataset.obxInitialised !== 'true') {
          initialiseToolbar(node);
        }
        node.querySelectorAll?.(TOOLBAR_SELECTOR).forEach((toolbar) => {
          if (toolbar.dataset.obxInitialised !== 'true') initialiseToolbar(toolbar);
        });
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
